import { useFieldHelper } from 'framework/ui/field';
import { CustomBadge } from 'framework/ui/ui-builder';
import { SERVICE_CATALOG_HEALTH_STATUSES } from 'domain/shared/serviceCatalog';
import {
  SERVICE_HEALTH_ISSUES_IMPORTANCE,
  SERVICE_HEALTH_ISSUES_OPTIONS,
} from 'domain/organization/serviceCatalog/health/useServiceHealthService';
import { ChipOwnProps } from '@mui/material';

type ServiceCatalogStatusBadgeProps = {
  showNormal?: boolean;
  source: string;
};

const ServiceCatalogHealthBadge = ({ showNormal = false, source, ...props }: ServiceCatalogStatusBadgeProps) => {
  const colors: Record<string, ChipOwnProps['color']> = {
    [SERVICE_CATALOG_HEALTH_STATUSES.NORMAL]: 'default',
    [SERVICE_CATALOG_HEALTH_STATUSES.WARNING]: 'warning',
    [SERVICE_CATALOG_HEALTH_STATUSES.CRITICAL]: 'error',
  };

  const { getValue } = useFieldHelper<any[]>({ source });

  // TODO: Remove try-catch when health deployed on backend
  let issues: { text: string; color: ChipOwnProps['color'] }[];
  try {
    issues = getValue()
      .filter((issue: any) => issue.type in SERVICE_HEALTH_ISSUES_OPTIONS)
      .map((issue: any) => ({
        text: SERVICE_HEALTH_ISSUES_OPTIONS[issue.type],
        color: colors[SERVICE_HEALTH_ISSUES_IMPORTANCE[issue.type]],
      }));
  } catch (TypeError) {
    issues = [];
  }

  return (
    <>
      {issues.map(issue => (
        <CustomBadge text={issue.text} color={issue.color} {...props} />
      ))}
    </>
  );
};

export default ServiceCatalogHealthBadge;
